import { Typography, Box } from '@mui/material';

import { Footer } from '..';

/*
    [flex: 1    ] ← 위 여백
    [타이틀 + 부제]
    [flex: 0.618] ← 타이틀↔버튼 간격 (황금비의 작은 쪽)
    [버튼]
    [flex: 1.618] ← 아래 여백 (황금비의 큰 쪽)
    [Footer]
*/
function MaintenanceBody() {
    return (
        <Box
            sx={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                px: 2,
            }}>
            <Box sx={{ flex: 1 }} />
            <Typography align='center' variant='m_logo' color='primary.main'>
                {import.meta.env.VITE_SERVICE_TITLE}
            </Typography>
            <Typography align='center' variant='m_overline' color='primary.main' sx={{ mt: 1 }}>
                {import.meta.env.VITE_SERVICE_TAGLINE}
            </Typography>
            <Box sx={{ flex: 0.618 }} />
            <Typography align='center' color='text.primary' variant='m_titleM'>
                Under Maintenance
            </Typography>
            <Typography align='center' variant='body2' color='text.secondary' sx={{ mt: 1 }}>
                We're performing scheduled maintenance. We'll be back shortly.
            </Typography>
            <Box sx={{ flex: 1.618 }} />
            <Footer />
        </Box>
    );
}

export { MaintenanceBody };
